import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  AppBar, Toolbar, Typography, Button,
  Box, IconButton, Drawer, List,
  ListItem, ListItemButton, ListItemText
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'

const pages = [
  { label: 'Home', path: '/' },
  { label: 'My Reading', path: '/reading' },
  { label: 'Ask Pandit', path: '/ask' },
  { label: 'Compatibility', path: '/compatibility' },
  { label: 'Pricing', path: '/pricing' },
]

export default function Navbar() {
  const navigate = useNavigate()
  const location = useLocation()
  const [drawer, setDrawer] = useState(false)

  return (
    <>
      <AppBar position="sticky" elevation={0}
        sx={{ bgcolor: '#0D0B1A', borderBottom: '1px solid #1E1A3A' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>

          <Box
            onClick={() => navigate('/')}
            sx={{ display: 'flex', alignItems: 'center',
              gap: 1, cursor: 'pointer' }}>
            <AutoAwesomeIcon sx={{ color: '#8B7FFF', fontSize: 22 }} />
            <Typography fontWeight={600} fontSize={18}
              sx={{ color: '#A89EFF' }}>
              JyotishAI
            </Typography>
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5 }}>
            {pages.map(p => (
              <Button key={p.path}
                onClick={() => navigate(p.path)}
                sx={{
                  color: location.pathname === p.path
                    ? '#A89EFF' : '#8B85B8',
                  bgcolor: location.pathname === p.path
                    ? '#1E1A3A' : 'transparent',
                  borderRadius: 5,
                  fontSize: 13,
                  px: 2,
                  '&:hover': {
                    bgcolor: '#1A1530',
                    color: '#C5BFFF',
                  },
                }}>
                {p.label}
              </Button>
            ))}
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Button variant="contained"
              onClick={() => navigate('/reading')}
              sx={{ px: 3, fontSize: 13 }}>
              Get free reading
            </Button>
          </Box>

          <IconButton
            sx={{ display: { md: 'none' }, color: '#A89EFF' }}
            onClick={() => setDrawer(true)}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={drawer}
        onClose={() => setDrawer(false)}
        PaperProps={{ sx: { bgcolor: '#0D0B1A',
          borderLeft: '1px solid #1E1A3A' } }}>
        <Box sx={{ width: 240, pt: 2 }}>
          <List>
            {pages.map(p => (
              <ListItem key={p.path} disablePadding>
                <ListItemButton
                  onClick={() => { navigate(p.path); setDrawer(false) }}
                  sx={{ '&:hover': { bgcolor: '#1A1530' } }}>
                  <ListItemText
                    primary={p.label}
                    sx={{ color: '#E8E6FF' }} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  )
}